<mat-form-field fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent" class="location-field">
  <mat-label>{{ configData.label }}</mat-label>
  <input matInput autocomplete="off" type="{{ configData.type }}" class="autocomplete-search" [formControlName]="configData.name"
    [placeholder]="configData.placeHolder" [required]="configData.required" [matAutocomplete]="auto" (keyup)="getLocationList($event)"
    (change)="requireMatch()"    
  />
  <mat-error *ngIf="frmGroup.get(configData.name).errors">
    <mat-error *ngIf="frmGroup.get(configData.name).errors.required">      
      Required
    </mat-error>    
  </mat-error>  
  <mat-hint *ngIf="frmGroup.get(this.configData.name)['secondaryText'] && !noItemFound">
    <a style="text-decoration: none; cursor: pointer; color: rgba(0, 0, 0, 0.54); font-size: 12px" [href]="mapUrl" target="blank" matTooltip="Show in map">
      <mat-icon matPrefix color="accent">{{ configData.type === "SOURCE" ? "trip_origin" : "location_on" }}
      </mat-icon>
      {{ frmGroup.get(this.configData.name)['secondaryText'] }}  
    </a>
  </mat-hint>

  <mat-hint *ngIf = "noItemFound">
    <mat-error>       
      No record found for text entered
    </mat-error>   
  </mat-hint>
  <mat-error *ngIf="frmGroup.get(configData.name).errors"> 
      <mat-error *ngIf="frmGroup.get(configData.name).errors.selectFromList">
        Please select from list
      </mat-error>
      <mat-error *ngIf="frmGroup.get(configData.name).errors.NoOrderFound">       
          No record found for text entered
      </mat-error>           
  </mat-error>      
  <mat-autocomplete #auto="matAutocomplete">   
    <mat-option disabled style="cursor: not-allowed;" *ngIf="progressBar">
      <app-progress-spinner-v2></app-progress-spinner-v2>   
    </mat-option>   
    <mat-option *ngFor="let item of locationList" (onSelectionChange)="selectedLocation($event, item)" tabindex="0" [value]="item.locationId+' - '+item.locationName"
      class="autocomplete-location">      
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="0 0 40px">
          <mat-icon color="accent">{{locationIcon}}</mat-icon>
        </div>
        <div fxFlex="calc(100%-40px)">
          <span class="location-autocomplete-header">
            {{item.locationId}} - {{item.locationName}}
          </span>
          <br />
          <span class="location-autocomplete-detail">
            {{item.addressLine}},{{item.city}},{{item.postalCode}}, {{item.countryCode}}
          </span>
        </div>
      </div>
    </mat-option>    
  </mat-autocomplete>
  
</mat-form-field>